import styled from "styled-components";

export const TitleSC = styled("h1")`
  font-size: 40px;
  font-weight: 500;
  color: #001A72;
  text-align: center;
  margin-bottom: 72px !important;
  @media(max-width: 768px) {
    font-size: 32px;
    margin-bottom: 40px !important;
  }
`
